import React, { useState } from "react";
import { Box, Typography, IconButton, Snackbar } from "@mui/material";
import {
    Close,
    Share,
    FileDownload,
    DriveFileMove,
    Delete,
    Link as LinkIcon,
    MoreVert,
    RepartitionOutlined,
} from "@mui/icons-material";
import ProgressBar from "./ProgressBar";
import axios from "axios";
import { useUser } from "../hooks/Authorize";
import { useLocation } from "react-router-dom"; 
import { useTheme } from "../style/theme";


const SelectedToolbar = ({
    onClearSelection,
    item,
    handleMoreVertMenuOpen,
    setClikkleItems,
    setOpenSharingDialogModal,
    setOpenMoveDialogModal,
}) => {
    const { mode } = useTheme();

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [showProcessingSnackbar, setShowProcessingSnackbar] = useState(false);
    const [processingMessage, setProcessingMessage] = useState('');
    const platformUser = JSON.parse(localStorage.getItem("user"));
    const location = useLocation();

    var isTrashScreen = location.pathname === '/trash'


    // Internal click handlers
    const handleOnClickShare = () => {
        setOpenSharingDialogModal(true);

        console.log("Share clicked", item);
        // You can integrate share dialog or function here
    };

    const handleOnClickDownload = async () => {
        console.log("Download clicked", item);
        try {
            setShowProcessingSnackbar(true)
            setProcessingMessage("Downloading...")
            const response = await axios({
                method: 'get',
                url: `${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/download/${item._id}?userId=${platformUser._id}`,

                responseType: 'blob' // Important for file downloads
            });

            // Create a download link
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;

            // Set filename based on resource type
            const filename = item.type === 'folder' ? `${item.name}.zip` : item.name;
            link.setAttribute('download', filename);

            // Trigger download
            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            setShowProcessingSnackbar(false)
        } catch (error) {
            console.error('Download error:', error);
            setShowProcessingSnackbar(false)
        }
    };

    const handleOnClickMove = () => {
        setOpenMoveDialogModal(true)
        console.log("Move clicked", item);
        // Move logic
    };

    const handleOnClickDelete = async (restore = false) => {
        setShowProcessingSnackbar(true)
        setProcessingMessage(restore ? "Restoring..." : "Deleting...")
        try {
            var payload = {
                id: item._id,
                isTrashed: !item.isTrashed,
                userId: platformUser._id,
            }
            if (restore) {
                payload.restore = restore
            }
            if (item.isTrashed && restore === false) {
                payload.permanentDelete = true
            }
            console.log(item)
            console.log(payload)
            // setAnchorEl(null);;
            const response = await axios.put(`${process.env.REACT_APP_NODE_FILE_MANAGER_SERVER}/api/fs/${item._id}`, payload);
            console.log("API Response:", response.data);
            setClikkleItems((prevItems) =>
                prevItems.filter((currentItem) => {
                    // console.log(currentItem._id);
                    return currentItem._id !== item._id
                })
            );
        } catch (error) {
            console.error("Error calling API:", error);
        }
        setShowProcessingSnackbar(false)
        onClearSelection()
    };

    const handleOnClickLink = () => {
        var url = process.env.REACT_APP_DEVELOPMENT_SERVER + "/view"
        if (item.type === 'file') {
            url += "?id=" + item._id;
        } else {
            url += "?parentId=" + item._id;
        }
        navigator.clipboard.writeText(url);
        setSnackbarOpen(true);
    };

    const handleOnClickMore = (e) => {
        handleMoreVertMenuOpen(e, item);
    };

    return (
        <>

            <ProgressBar showProcessingSnackbar={showProcessingSnackbar} processingMessage={processingMessage} />


            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={() => setSnackbarOpen(false)}
                message="Link copied to clipboard"
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                sx={{
                    '& .MuiSnackbarContent-root': {
                        backgroundColor: "#191919",
                        background: "rgba(31, 31, 31, 1)",
                        color: '#fff',
                    }
                }}
            />

            <Box
                id="selected-toolbar"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between", 
                    backgroundColor: mode==='dark'? "rgba(31, 31, 31, 1)" :"rgba(239, 239, 239, 1)", 
                
                    borderRadius: "999px",
                    paddingY: "4px",
                    paddingX: "16px",
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                    height: 48,
                    width: "90%",
                }}
            >
                <Box display="flex" alignItems="center" gap={1}>
                    <IconButton onClick={onClearSelection} sx={{ padding: "4px" }}>
                        <Close fontSize="small" />
                    </IconButton>
                    <Typography variant="body2" fontWeight={500}>
                        1 selected
                    </Typography>

                    <IconButton onClick={handleOnClickShare} sx={{ padding: "4px", marginLeft: "15px" }}>
                        <Share fontSize="small" />
                    </IconButton>
                    <IconButton onClick={handleOnClickDownload} sx={{ padding: "4px" }}>
                        <FileDownload fontSize="small" />
                    </IconButton>
                    <IconButton onClick={handleOnClickMove} sx={{ padding: "4px" }}>
                        <DriveFileMove fontSize="small" />
                    </IconButton>


                    {
                        isTrashScreen &&
                        <IconButton onClick={() => handleOnClickDelete(true)} sx={{ padding: "4px" }}>
                            <RepartitionOutlined fontSize="small" />
                        </IconButton>
                    }
                    <IconButton onClick={() => handleOnClickDelete()} sx={{ padding: "4px" }}>
                        <Delete fontSize="small" />
                    </IconButton>

                    <IconButton onClick={handleOnClickLink} sx={{ padding: "4px" }}>
                        <LinkIcon fontSize="small" />
                    </IconButton>
                    <IconButton onClick={handleOnClickMore} sx={{ padding: "4px" }}>
                        <MoreVert fontSize="small" />
                    </IconButton>
                </Box>
            </Box>
        </>
    );
};

export default SelectedToolbar;
